import {
  SERVICE_HOLDER_TOILET_LEVEL_AUTONOMOUS,
  SERVICE_HOLDER_TOILET_LEVEL_BEDRIDDEN,
  SERVICE_HOLDER_TOILET_LEVEL_NEEDS_HELP,
  SERVICE_HOLDER_TOILET_LEVEL_OTHERS,
  SERVICE_HOLDER_TOILET_LEVEL_WEARS_A_DIAPER,
} from "./serviceHolder";

const levels = [
  {
    value: SERVICE_HOLDER_TOILET_LEVEL_AUTONOMOUS,
  },
  {
    value: SERVICE_HOLDER_TOILET_LEVEL_NEEDS_HELP,
  },
  {
    value: SERVICE_HOLDER_TOILET_LEVEL_WEARS_A_DIAPER,
  },
  {
    value: SERVICE_HOLDER_TOILET_LEVEL_BEDRIDDEN,
  },
  {
    value: SERVICE_HOLDER_TOILET_LEVEL_OTHERS,
  },
];

export function toiletLevelsList() {
  return levels;
}
